export const environment = {
  production: true,
  baseUrl: "https://suomenyrittajaturva-backend.imsd.ateafinland.fi",
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts